export const feedbackModal = {
  extends: 'ModalWindow',
  ModalHeader: {
    title: 'Let us know',
  },
  Flex: {},
};